import React, { useEffect, useState } from "react";
import LoadCSSforfirstTime from "../../../../../CloudStorage/LoadCSSforfirstTime";
import CloudStorage from "../../../../../CloudStorage/CloudStorage";
import { useNavigate } from "react-router-dom";
import getTimeDifference from "../../../../Common/TimeDifference";
import DownloadwithDisplayProper from "../../../../Common/FilesRelevent/DownloadwithDisplayProper";
import { formatNumberWithCommas, getPosttype } from "../../../../Common/AllDateTimeReleventFormate";
import { Tooltip } from "react-tooltip";
import CustomeMilestone from "../../../../Common/CustomeLabel/CustomeMilestone";
import CustomeDurationLabel from "../../../../Common/CustomeLabel/CustomeDurationLabel";
import CustomReactQuillDescription from "../../../../Common/CustomeLabel/ReactQuill/CustomReactQuillDescription";
import CustomeCategoryandSubcategory from "../../../../Common/CustomeLabel/CustomeCategoryandSubcategory";
import CommonAbouttheClient from "../../../../Common/CommonAbouttheClient";
import { decodeHtml } from "../../../../../assests/extention/commonfunction";

export default function ManageAppliedProjectDetails({ posts }) {
  const laung = localStorage.getItem("laung");
  const [lan, setLan] = useState(laung ?? "en");
  const path = "Assets/scss/FindWork.module.scss";
  useEffect(() => {
    LoadCSSforfirstTime(path);
  }, [path]);

  const navigate = useNavigate();

  return (
    <div className=" project-section project-details p-0">
      <div className="post-details">
        <div className="post-flex">
          <div>
            <h5>
              {decodeHtml(posts.title)} <span className="project">{getPosttype(posts.type)}</span>
            </h5>
            <div className="dollar-sec">
              <p>
                <img
                  src={`${CloudStorage.cloudurl}/Assets/Images/project/dollar.svg`}
                  alt=""
                />
                {posts?.type == 2 ? "Prize" : "Budget"}: $
                {formatNumberWithCommas(posts.price)}
                {posts?.type == 3 &&
                  (posts?.hiring_type == 1 ? "/hour" : "/month")}
              </p>
              <p>
                <img
                  src={`${CloudStorage.cloudurl}/Assets/Images/project/hourglass.svg`}
                  alt=""
                />
                Deadline:&nbsp;
                <CustomeDurationLabel
                  duration={posts?.duration}
                  duration_type={posts?.duration_type}
                />
              </p>
              <p>
                <img
                  src={`${CloudStorage.cloudurl}/Assets/Images/project/message.svg`}
                  alt=""
                />
                Posted:{getTimeDifference(posts?.created_on)}
              </p>
            </div>
          </div>
        </div>
        <CustomeCategoryandSubcategory posts={posts} />
        <div className="lang-sec">
          <h6>Preferred language</h6>
          <p>{decodeHtml(posts?.language_title)}</p>
        </div>
        <div className="lang-sec">
          <h6>Description</h6>
          <CustomReactQuillDescription value={posts?.description} />
        </div>
        <div className="lang-sec">
          <h6>Competencies and expertise</h6>
          <div className="skills-expert">
            <div className="photoshop">
              {Array.isArray(posts?.skills) &&
                posts?.skills.map((item1, index1) => (
                  <p key={index1}>{decodeHtml(item1.title)}</p>
                ))}
            </div>
          </div>
        </div>
        {Array.isArray(posts?.files) &&
          posts?.files &&
          posts?.files?.length > 0 && (
            <div className="lang-sec">
              <h6>Attachments</h6>
              <div className="images">
                {posts?.files &&
                  Array.isArray(posts?.files) &&
                  posts?.files.map((item, index) => {
                    return <DownloadwithDisplayProper item={item} />;
                  })}
              </div>
            </div>
          )}
        <div className="lang-sec">
          <h6>Deliverables</h6>
          <CustomReactQuillDescription value={posts?.deliverables} />
        </div>
        <CustomeMilestone milestones={posts?.milestones} />
        <div className="lang-sec">
          <h6 className="activity-post"> Activity on this post</h6>
          <div className="post-p">
            <p>
              <img
                src={`${CloudStorage.cloudurl}/Assets/Images/project/post-proposal.svg`}
                alt=""
              />
              Proposal: {posts?.proposal_count}
            </p>
            <p>
              <img
                src={`${CloudStorage.cloudurl}/Assets/Images/project/eye.svg`}
                alt=""
              />
              Last viewed by client:
              {getTimeDifference(posts?.last_viewed_client)}
            </p>
            <p>
              <img
                src={`${CloudStorage.cloudurl}/Assets/Images/project/interview.svg`}
                alt=""
              />
              Seen: {posts?.view_count}
            </p>
          </div>
        </div>
        <CommonAbouttheClient posts={posts} />
      </div>
    </div>
  );
}
